import { useEffect, useState } from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import TrackingInfoForm from '../../components/embed/tracking-info/TrackingInfoForm'
import TrackingInfoResult from '../../components/embed/tracking-info/TrackingInfoResult'
import Axios from 'axios'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 320,
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  loadingRoot: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

const TrackingInfoEmbed = () => {
  const classes = useStyles()
  const Router = useRouter()

  const [trackingCode, setTrackingCode] = useState('')
  const [trackingData, setTrackingData] = useState(false)
  const [notFoundStatus, setNotFoundStatus] = useState(false)
  const [readyToRender, setReadyToRender] = useState(false)

  const handleSearch = async (trackingCode) => {
    try {
      const res = await Axios.post('/api/tracking/domestic', {
        tracking_code: trackingCode,
      })
      const resData = res.data
      setTrackingData(resData)
      setNotFoundStatus(false)
    } catch (err) {
      setTrackingData(false)
      setNotFoundStatus(true)
    } finally {
      setReadyToRender(true)
    }
  }

  const onSubmit = () => {
    handleSearch(trackingCode)
  }

  const resetWidget = () => {
    setTrackingData(false)
    setNotFoundStatus(false)
  }

  useEffect(() => {
    if (!Router.isReady) return
    const queryTrackingCode = Router.query.tracking_code
    if (queryTrackingCode) {
      setTrackingCode(queryTrackingCode)
      handleSearch(queryTrackingCode)
    } else {
      setReadyToRender(true)
    }
  }, [Router.isReady])

  if (!readyToRender)
    return (
      <div className={clsx(classes.root, classes.loadingRoot)}>
        <div style={{ height: 100 }} />
        <CircularProgress />
      </div>
    )
  return (
    <div className={classes.root}>
      {trackingData ? (
        <TrackingInfoResult data={trackingData} resetWidget={resetWidget} />
      ) : (
        <TrackingInfoForm
          trackingCode={trackingCode}
          setTrackingCode={setTrackingCode}
          onSubmit={onSubmit}
          notFoundStatus={notFoundStatus}
        />
      )}
    </div>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['tracking'])),
  },
})

export default TrackingInfoEmbed
